// extracted by mini-css-extract-plugin
export default {"Timeline_Item":"TimelineRow-module__Timeline_Item--JB78Z","Octicon":"TimelineRow-module__Octicon--nrVo5"};